<template>
  <div>
    <toastification-loading-content ref="loadingToast" />
    <WizardModal
      modal-id="wizard-modal"
      :is-active="isWizardActive"
      @update:isActive="onUpdateIsActive"
      :is-add="isAdd"
      :allow-direct-step-navigation="!isAdd"
      :wizard-title="wizardTitle"
      :steps="wizardSteps"
      :step-icons="wizardStepIcons"
      :finishAtStep="finishAtStep"
      :current-step="currentStep"
      :current-step-key="currentStepKey"
      :show-previous-button="currentStep > 0"
      :show-save-button="!isAdd && currentStep < finishAtStep"
      :show-next-button="currentStep < finishAtStep"
      :show-finish-button="currentStep === finishAtStep"
      :activate-btn-save="activateBtnSave"
      @close-wizard="closeWizard"
      @prev-step="prevStep"
      @next-step="nextStep"
      @go-to-step="goToStep"
      @save-data="handleSave"
      @load-data="loadData"
      @reset-wizard="resetData"
      @on-submit="onSubmit"
      size="xl"
    >
      <template #step-general="{ currentStep, loading }">
        <GeneralInfoStep
          ref="generalInfoStepRef"
          :is-add.sync="isAdd"
          :prop-item-data="itemData"
          :category-options="categoryOptions"
          :unit-deactivation-catalog-options="unitDeactivationCatalogOptions"
          @update:itemData="itemData = { ...itemData, ...$event }"
        />
      </template>
      <template #step-ubication="{ currentStep, loading }">
        <div
          class="h-100 w-100 d-flex justify-content-center align-items-center"
          v-if="loadingStep"
        >
          <b-spinner small></b-spinner>
        </div>
        <UbicationStep
          v-else
          ref="ubicationStepRef"
          :is-add.sync="isAdd"
          :prop-item-data="itemData"
          :tenant-options="tenantOptions"
          :country-options="countryOptions"
          :region-options="regionOptions"
          :municipality-options="municipalityOptions"
          :sector-options="sectorOptions"
          :center-options="centerOptions"
          :timezone-options="timezoneOptions"
          @update:itemData="itemData = { ...itemData, ...$event }"
        />
      </template>
      <template #step-additional="{ currentStep, loading }">
        <div
          class="h-100 w-100 d-flex justify-content-center align-items-center"
          v-if="loadingStep"
        >
          <b-spinner small></b-spinner>
        </div>
        <AdditionalInfoStep
          v-else
          ref="additionalInfoStepRef"
          :is-add.sync="isAdd"
          :prop-item-data="itemData"
          @update:itemData="itemData = { ...itemData, ...$event }"
          @fecth-data="$emit('refetch-data')"
        />
      </template>
      <template #step-emergency="{ currentStep, loading }">
        <div
          class="h-100 w-100 d-flex justify-content-center align-items-center"
          v-if="loadingStep"
        >
          <b-spinner small></b-spinner>
        </div>
        <EmergencyContactsStep
          v-else
          ref="emergencyContactsStepRef"
          :is-add.sync="isAdd"
          :prop-item-data="itemData"
          @update:itemData="itemData = { ...itemData, ...$event }"
        />
      </template>
      <template #step-devices="{ currentStep, loading }">
        <div
          class="h-100 w-100 d-flex justify-content-center align-items-center"
          v-if="loadingStep"
        >
          <b-spinner small></b-spinner>
        </div>
        <DevicesStep
          v-else
          ref="devicesStepRef"
          :is-add.sync="isAdd"
          :prop-item-data="itemData"
          @update:itemData="itemData = { ...itemData, ...$event }"
        />
      </template>
      <!-- deleted step 4 (RiskAssessmentStep) -->
      <!-- <template #step-4="{ currentStep, loading }">
        <div
          class="h-100 w-100 d-flex justify-content-center align-items-center"
          v-if="loadingStep"
        >
          <b-spinner small></b-spinner>
        </div>
        <RiskAssessmentStep
          v-else
          ref="riskEvaluationStepRef"
          :is-add.sync="isAdd"
          :prop-item-data="itemData"
          @update:itemData="itemData = { ...itemData, ...$event }"
        />
      </template> -->
    </WizardModal>
    <UnitDuplicateDialog
      v-model="dupDialog.show"
      :existing="dupDialog.existing"
      :rems="itemData.rems"
      :sirh="itemData.sirh"
      @create-merge-all="handleCreateAndMergeAll"
    />
  </div>
</template>
<script>
import { ref, computed, onMounted, watch, nextTick } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import WizardModal from "@/components/WizardModal/Index.vue";
import GeneralInfoStep from "./GeneralInfoStep.vue";
import formValidation from "@/@core/comp-functions/forms/form-validation";
import UbicationStep from "./UbicationStep.vue";
import EmergencyContactsStep from "./EmergencyContactsStep.vue";
import RiskAssessmentStep from "./RiskAssessmentStep.vue";
import AdditionalInfoStep from "./AdditionalInfoStep/Index.vue";
import UnitDuplicateDialog from "./UnitDuplicateDialog.vue";
import axios from "@axios";
import DevicesStep from "./DevicesStep.vue";
import ability from "@/libs/acl/ability";

export default {
  components: {
    WizardModal,
    GeneralInfoStep,
    UbicationStep,
    EmergencyContactsStep,
    RiskAssessmentStep,
    AdditionalInfoStep,
    UnitDuplicateDialog,
    ToastificationContent,
    ToastificationLoadingContent,
    DevicesStep
  },
  props: {
    isWizardActive: {
      type: Boolean,
      required: true,
    },
    itemEdit: {
      type: Object,
      required: false,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    categoryOptions: {
      type: Array,
      required: true,
    },
    unitDeactivationCatalogOptions: {
      type: Array,
      required: true,
    },
    tenantOptions: {
      type: Array,
      required: true,
    },
    countryOptions: {
      type: Array,
      required: true,
    },
    regionOptions: {
      type: Array,
      required: true,
    },
    municipalityOptions: {
      type: Array,
      required: true,
    },
    sectorOptions: {
      type: Array,
      required: true,
    },
    centerOptions: {
      type: Array,
      require: true,
    },
    timezoneOptions: {
      type: Array,
      require: true
    }
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const toast = useToast();
    const trans = computed(() => ({
      "users.info": t("users.info"),
      "unit.location": t("unit.location"),
      "unit.emergency_contacts": t("unit.emergency_contacts"),
      "bosch.devices.devices": t("bosch.devices.devices"),
      "risk.risk_evaluations_title": t("risk.risk_evaluations_title"),
      "messages.export.download": t("messages.export.download"),
      "messages.export.Generating_file": t("messages.export.Generating_file"),
      "messages.error.server_error": t("messages.error.server_error"),
      "messages.delete.title": t("messages.delete.title"),
      "messages.delete.body": t("messages.delete.body"),
      "actions.delete": t("actions.delete"),
      "actions.cancel": t("actions.cancel"),
      "messages.edit_save.successfully_created": t(
        "messages.edit_save.successfully_created"
      ),
      "messages.edit_save.updated_successfully": t(
        "messages.edit_save.updated_successfully"
      ),
      "messages.validation.missing_fields.title": t(
        "messages.validation.missing_fields.title"
      ),
      "messages.validation.missing_fields.text": t(
        "messages.validation.missing_fields.text"
      ),
      additional_info: t("unit.additional_info"),
      "unit.required_deactivation_catalog": t("unit.required_deactivation_catalog"),
      "unit.required_comment": t("unit.required_comment"),
    }));

    const loadingStep = ref(false);

    const generalInfoStepRef = ref(null);
    const ubicationStepRef = ref(null);
    const additionalInfoStepRef = ref(null);
    const emergencyContactsStepRef = ref(null);
    const riskEvaluationStepRef = ref(null);
    const devicesStepRef = ref(null);
    const wizardTitle = "Wizard Setup";
    const showAllUnitSteps = ref(false);
    const activeSteps = computed(() => [
      {
        key: "general",
        label: trans.value["users.info"],
        icon: "ToolIcon",
        visible: showAllUnitSteps.value || ability.can("update_general_info", "Units"),
      },
      {
        key: "ubication",
        label: trans.value["unit.location"],
        icon: "MapIcon",
        visible: showAllUnitSteps.value || ability.can("update_location", "Units"),
      },
      {
        key: "additional",
        label: trans.value["additional_info"],
        icon: "InfoIcon",
        visible: showAllUnitSteps.value || ability.can("update_additional_info", "Units"),
      },
      {
        key: "emergency",
        label: trans.value["unit.emergency_contacts"],
        icon: "PhoneIcon",
        visible: showAllUnitSteps.value || ability.can("update_emergency_contacts", "Units"),
      },
      {
        key: "devices",
        label: trans.value["bosch.devices.devices"],
        icon: "TvIcon",
        visible: showAllUnitSteps.value || ability.can("update_devices", "Units"),
      },
    ].filter((step) => step.visible));
    const wizardSteps = computed(() => activeSteps.value.map((step) => step.label));
    const wizardStepIcons = computed(() => activeSteps.value.map((step) => step.icon));
    const currentStepKey = computed(() => activeSteps.value[currentStep.value]?.key || "");
    const finishAtStep = computed(() => activeSteps.value.length - 1);
    const currentStep = ref(0);
    const isUpdate = ref(false);
    // Serialized copy of the last persisted state, not a reference to it: the
    // steps share the very same `itemData` object, so holding a reference let
    // them mutate the baseline in place and a real edit read as "no change".
    const savedStateSnapshot = ref(null);
    const isInitialLoadComplete = ref(false);

    const stepRefs = computed(() => ({
      general: generalInfoStepRef.value,
      ubication: ubicationStepRef.value,
      additional: additionalInfoStepRef.value,
      emergency: emergencyContactsStepRef.value,
      devices: devicesStepRef.value,
    }));

    const blankData = {
      active_digital_output: 0,
      active: 1,
      address_1: "",
      address_2: "",
      allow_virtual_button_alarm: 0,
      alt: "0",
      comments: "",
      company: "",
      description: "",
      driver: "",
      emergency_contact: [],
      id_country: "",
      id_region: "",
      id_tenant: "",
      id_category: "",
      imei: "",
      idTotem: "",
      img_unit: "",
      ip_vpn: "",
      lat: "0",
      lng: "0",
      installation_date: null,
      c5_cabinet_label: "",
      router_serial_number: "",
      mac_address: "",
      router_brand: "",
      router_model: "",
      c5_router_label: "",
      brand_model: "",
      notify_c5_cdmx: 0,
      notify_c5_jal: 0,
      number: "",
      owner: "",
      plate_number: "",
      postal_code: "",
      provider: "",
      reaction_patrol: "",
      route: "",
      suburb: "",
      time_zone: "",
      totemKey: "",
      vehicle: 0,
      vin: "",
      desactivate: null,
      disable: "0",
      isUnitDisabled: false,
      user: "",
      password: "",
      router: {
        deactivation: {
          comment: "",
          reactivation_date: null,
          id_deactivation_catalog: null,
          deleted: 1,
          attachments: [],
        },
      },
      additional_info: [],
      rems: "",
      sirh: "",
      id_sector: null,
      id_center: null,
      additional_routers: [],
      hasRouter: 0,
      is_main_unit: false,
      needs_check: 1,
      force_network_mask: 1,
      is_saturday: false,
      id_cashier: null,
    };

    const itemData = ref(JSON.parse(JSON.stringify(blankData)));
    const activateBtnSave = ref(false);

    watch(
      () => itemData.value,
      (newVal) => {
        if (props.isAdd) {
          isUpdate.value =
            !!newVal.description?.trim() &&
            !!newVal.id_tenant &&
            !!newVal.id_municipality;
        } else {
          isUpdate.value = true;
        }
      },
      { deep: true }
    );

    const closeWizard = () => {
      resetData();
      isUpdate.value = false;
      activateBtnSave.value = false;
      emit("update:is-wizard-active", false);
    };

    const onUpdateIsActive = (value) => {
      emit("update:is-wizard-active", value);
    };
    const prevStep = () => {
      currentStep.value -= 1;
    };

    const goToStep = (step) => {
      if (!props.isAdd && step >= 0 && step < activeSteps.value.length) {
        currentStep.value = step;
      }
    };

    const validateCurrentStep = async () => {
      await nextTick();

      const currentRef = stepRefs.value[currentStepKey.value];

      if (currentRef && typeof currentRef.validateStep === "function") {
        const validation = await currentRef.validateStep();
        return validation;
      }

      return true;
    };

    const nextStep = async () => {
      try {
        const isValid = await validateCurrentStep();

        if (isValid) {
          const nextStepData = activeSteps.value[currentStep.value + 1];
          if (!nextStepData) {
            return;
          }
          loadingStep.value = true;

          // On edit every step persists on the way out, first one included;
          // on add the record can only be created once the location step has
          // supplied tenant and municipality.
          if (currentStepKey.value !== "general" || !props.isAdd) {
            const saveSuccessful = await saveData(false);

            if (!saveSuccessful) {
              return;
            }
          }
          currentStep.value++;
        }
      } catch (error) {
        console.error("Error during step validation or save:", error);
      } finally {
        loadingStep.value = false;
      }
    };

    const handleSave = async () => {
      await saveData(false);
    };

    const onSubmit = async () => {
      const saveSuccessful = await saveData(true);
      if (!saveSuccessful) {
        return false;
      }
    };

    const loadData = () => {
      showAllUnitSteps.value = props.isAdd;
      currentStep.value = 0;

      if (props.isAdd) {
        itemData.value = { ...JSON.parse(JSON.stringify(blankData)) };
        if (props.tenantOptions.length === 1)
          itemData.value.id_tenant = props.tenantOptions[0].value;
        if (props.countryOptions.length === 1)
          itemData.value.id_country = props.countryOptions[0].value;
      } else {
        // Ensure router.deactivation structure always exists
        const baseRouter = props.itemEdit.router || {};
        const baseDeactivation = baseRouter.deactivation || {
          comment: "",
          reactivation_date: null,
          id_deactivation_catalog: null,
          deleted: 1,
        };

        // Check if unit is disabled (deleted === 0 means unit is deactivated)
        const isDisabled = baseDeactivation.deleted === 0;

        itemData.value = {
          ...props.itemEdit.router,
          ...props.itemEdit,
          hasRouter: 1,
          isUnitDisabled: isDisabled,
          router: {
            ...baseRouter,
            deactivation: {
              comment: baseDeactivation.comment || "",
              reactivation_date: baseDeactivation.reactivation_date || null,
              id_deactivation_catalog: baseDeactivation.id_deactivation_catalog || null,
              deleted: baseDeactivation.deleted !== undefined ? baseDeactivation.deleted : 1,
              attachments: baseDeactivation.attachments || [],
            },
          },
        };

        const validCountryIds = (props.countryOptions || []).map((c) => c.value);
        if (
          validCountryIds.length &&
          !validCountryIds.includes(itemData.value.id_country)
        ) {
          const derivedCountry =
            props.itemEdit.country?.id ?? props.itemEdit.region?.country_id ?? null;
          itemData.value.id_country = validCountryIds.includes(derivedCountry)
            ? derivedCountry
            : null;
        }

        savedStateSnapshot.value = JSON.stringify(itemData.value);
        isInitialLoadComplete.value = true;
      }
    };

    // Registered here instead of behind a timer: while the watcher did not
    // exist yet, edits made right after opening went unnoticed and left the
    // save button disabled for good.
    watch(
      () => JSON.stringify(itemData.value),
      (serialized) => {
        if (!isInitialLoadComplete.value) return;
        activateBtnSave.value = serialized !== savedStateSnapshot.value;
      }
    );

    const resetData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankData));
      currentStep.value = 0;
      isUpdate.value = false;
      isInitialLoadComplete.value = false;
      savedStateSnapshot.value = null;
      activateBtnSave.value = false;
      emit("update:is-wizard-active", false);
    };

    const attemptAxios = async (method, url, data) => {
      return axios({
        method,
        url,
        data,
        validateStatus: (status) => status >= 200 && status < 500,
      });
    };

    const saveData = async (shouldClose = false) => {
      loadingStep.value = true;
      try {
        if (!itemData.value.description || itemData.value.description.trim() === "") {
          throw new Error("El campo 'Descripción' es obligatorio");
        }

        const validCountryIds = (props.countryOptions || []).map((c) => c.value);
        if (
          validCountryIds.length &&
          !validCountryIds.includes(itemData.value.id_country)
        ) {
          currentStep.value = 1;
          toast({
            component: ToastificationContent,
            props: {
              title: trans.value["messages.validation.missing_fields.title"],
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          loadingStep.value = false;
          return false;
        }

        // validar campos de disable unit
        if (itemData.value.isUnitDisabled) {
          if (!itemData.value.router?.deactivation?.id_deactivation_catalog) {
            toast({
              component: ToastificationContent,
              props: {
                title: trans.value["unit.required_deactivation_catalog"],
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
            loadingStep.value = false;
            return false;
          }
          if (!itemData.value.router?.deactivation?.comment || itemData.value.router.deactivation.comment.trim() === "") {
            toast({
              component: ToastificationContent,
              props: {
                title: trans.value["unit.required_comment"],
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
            loadingStep.value = false;
            return false;
          }
        }

        if (itemData.value.emergency_contact.length) {
          const emergencyContactsArray =  itemData.value.emergency_contact;

          itemData.value.emergency_contact = emergencyContactsArray.filter(
            (contact) => (contact.name.trim() && contact.phone_number.trim() && contact.description.trim())
          );
        }

        // Prepare deactivation data
        let deactivationData = null;
        let newFiles = [];
        let existingFiles = [];

        if (itemData.value.isUnitDisabled && itemData.value.router?.deactivation) {
          const attachments = itemData.value.router.deactivation.attachments || [];

          attachments.forEach(att => {
            if (att.isNew && att.file) {
              newFiles.push(att.file);
            } else if (att.path) {
              existingFiles.push(att.path);
            }
          });

          deactivationData = {
            comment: itemData.value.router.deactivation.comment,
            reactivation_date: itemData.value.router.deactivation.reactivation_date,
            id_deactivation_catalog: itemData.value.router.deactivation.id_deactivation_catalog,
            deleted: 0,
          };
        }

        const basePayload = {
          ...itemData.value,
          id_center: itemData.value.id_center,
          id_sector: itemData.value.id_sector,
          desactivate:
            itemData.value.disable === "1"
              ? {
                  ...itemData.value.desactivate,
                  comment:
                    itemData.value.desactivate?.comment &&
                    itemData.value.desactivate.comment.trim() !== ""
                      ? itemData.value.desactivate.comment
                      : "Desactivaction unit",
                }
              : null,
          deactivation: deactivationData,
          imei:
            !itemData.value.imei || itemData.value.imei.startsWith("IMEI_")
              ? `IMEI_${itemData.value.description}`
              : itemData.value.imei,
        };

        const url = itemData.value.id ? `v1/unit/${itemData.value.id}` : "v1/unit";
        let method = itemData.value.id ? "put" : "post";

        let response;

        // if there are new files, use FormData
        if (newFiles.length > 0) {
          const formData = new FormData();

          Object.keys(basePayload).forEach(key => {
            if (basePayload[key] !== null && basePayload[key] !== undefined) {
              if (typeof basePayload[key] === 'object') {
                formData.append(key, JSON.stringify(basePayload[key]));
              } else {
                formData.append(key, basePayload[key]);
              }
            }
          });

          newFiles.forEach((file) => {
            formData.append('deactivation_attachments[]', file);
          });

          if (existingFiles.length > 0) {
            existingFiles.forEach((path) => {
              formData.append('deactivation_existing_attachments[]', path);
            });
          }

          if (itemData.value.id) {
            formData.append('_method', 'PUT');
            method = 'post';
          }

          response = await axios({
            method: method,
            url: url,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            validateStatus: (status) => status >= 200 && status < 500,
          });
        } else {
          if (existingFiles.length > 0) {
            basePayload.deactivation_existing_attachments = existingFiles;
          }
          response = await attemptAxios(method, url, basePayload);
        }

        if (response.status >= 200 && response.status < 300) {
          toast({
            component: ToastificationContent,
            props: {
              title: itemData.value.id
                ? trans.value["messages.edit_save.updated_successfully"]
                : trans.value["messages.edit_save.successfully_created"],
              icon: "CheckIcon",
              variant: "success",
            },
          });

          if (!itemData.value.id && response.data.data?.id) {
            itemData.value.id = response.data.data.id;
          }

          itemData.value.additional_routers = response.data.data.additional_routers?.map(router => ({
            ...router,
            hasRouter: 1,
          }));

          // Re-baseline, otherwise undoing an edit back to the value the unit
          // had when the wizard opened would disable the button and lose the
          // correction that is already stored server side.
          savedStateSnapshot.value = JSON.stringify(itemData.value);
          activateBtnSave.value = false;

          emit("refetch-data");

          if (shouldClose) {
            resetData();
            emit("update:is-wizard-active", false);
          }

          return true;
        } else if (
          response.status === 409 &&
          response.data?.code === "DUPLICATE_REMS_OR_SIRH"
        ) {
          dupDialog.value.existing = response.data.data?.existing || null;
          dupDialog.value.show = true;
          return false;
        } else if (response.status === 422 || response.status === 400) {
          let string = "";
          Object.entries(response.data.data || {}).forEach(([key, value]) => {
            string += `${key} - ${value}<br>`;
          });
          toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: string,
            },
          });
          return false;
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || "Error",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return false;
        }
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: error.message || "Error desconocido",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } finally {
        loadingStep.value = false;
      }
    };

    const dupDialog = ref({
      show: false,
      existing: null,
    });

    const createWithoutIdentifiers = async () => {
      const backupRems = itemData.value.rems;
      const backupSirh = itemData.value.sirh;
      const payload = JSON.parse(JSON.stringify(itemData.value));
      payload.rems = null;
      payload.sirh = null;

      if (!payload.imei || String(payload.imei).startsWith("IMEI_")) {
        const desc = (payload.description || "AUTO").replace(/\s+/g, "_").slice(0, 48);
        payload.imei = `IMEI_${desc}`;
      }

      const res = await axios.post("v1/unit", payload, {
        validateStatus: (s) => s >= 200 && s < 500,
      });
      if (res.status >= 200 && res.status < 300) {
        if (res.data?.data?.id) {
          itemData.value.id = res.data.data.id;
        }
        itemData.value.rems = backupRems;
        itemData.value.sirh = backupSirh;
        return itemData.value.id;
      } else {
        throw new Error(res.data?.message || "No se pudo crear la Unit sin REMS/SIRH");
      }
    };

    const mergeStart = async (targetId, sourceId) => {
      const res = await axios.post(
        "v1/unit/merge/start",
        { target_id: targetId, source_id: sourceId },
        { validateStatus: (s) => s >= 200 && s < 500 }
      );
      if (!(res.status >= 200 && res.status < 300))
        throw new Error(res.data?.message || "Error en mergeStart");
      return res.data;
    };

    const mergeTransfer = async (targetId, sourceId) => {
      const res = await axios.post(
        "v1/unit/merge/transfer",
        { target_id: targetId, source_id: sourceId },
        { validateStatus: (s) => s >= 200 && s < 500 }
      );
      if (!(res.status >= 200 && res.status < 300))
        throw new Error(res.data?.message || "Error en mergeTransfer");
      return res.data;
    };

    const mergeFinalize = async (sourceId) => {
      const res = await axios.post(
        "v1/unit/merge/finalize",
        { source_id: sourceId },
        { validateStatus: (s) => s >= 200 && s < 500 }
      );
      if (!(res.status >= 200 && res.status < 300))
        throw new Error(res.data?.message || "Error en mergeFinalize");
      return res.data;
    };

    const handleCreateAndMergeAll = async () => {
      try {
        if (!dupDialog.value.existing || !dupDialog.value.existing.id) return;

        let targetId = itemData.value.id;

        if (!targetId) {
          targetId = await createWithoutIdentifiers();
        }

        const sourceId = dupDialog.value.existing.id;

        await mergeStart(sourceId, targetId);
        await mergeTransfer(sourceId, targetId);
        await mergeFinalize(targetId);

        const refreshed = await axios.get(`v1/unit/${sourceId}`, {
          validateStatus: (s) => s < 500,
        });
        if (refreshed.status >= 200 && refreshed.status < 300) {
          itemData.value = { ...itemData.value, ...(refreshed.data?.data || {}) };
        }

        dupDialog.value.show = false;

        toast({
          component: ToastificationContent,
          props: {
            title: "Merge completado",
            icon: "CheckIcon",
            variant: "success",
          },
        });

        emit("refetch-data");
      } catch (e) {
        toast({
          component: ToastificationContent,
          props: {
            title: e.message || "Error en merge",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    };

    onMounted(() => {
      if (props.isAdd) {
        setTimeout(() => {
          props.countryOptions.forEach((element) => {
            if (element.label == "usa (+1)") itemData.value.id_country = element.value;
          });
        }, 300);
        itemData.value.active = 0;
        emit("update:itemData", { ["active"]: 0 });
      }
    });

    return {
      itemData,
      wizardTitle,
      wizardSteps,
      wizardStepIcons,
      finishAtStep,
      currentStep,
      currentStepKey,
      closeWizard,
      onUpdateIsActive,
      prevStep,
      goToStep,
      nextStep,
      generalInfoStepRef,
      ubicationStepRef,
      additionalInfoStepRef,
      emergencyContactsStepRef,
      devicesStepRef,
      riskEvaluationStepRef,
      handleSave,
      loadData,
      resetData,
      onSubmit,
      isUpdate,
      loadingStep,
      activateBtnSave,
      saveData,
      dupDialog,
      handleCreateAndMergeAll,
    };
  },
};
</script>
<style></style>
